import { z } from "zod";

// Snake_case matches Glepnir's PasswordResetLinkPayload, which Branch.io
// forwards as-is on the desktop fallback. The Bifrost confirm endpoint still
// expects camelCase `userId` in its body.
export const resetPasswordSearchSchema = z.object({
  user_id: z.coerce.number().int().positive(),
  token: z.string().min(1),
});
